import React from 'react';
import {
  Box,
  Button,
  Icons,
  IconButton,
  Modal,
  Tooltip,
  Typography,
} from '@ublend-npm/aulaui-core';
import { createStyles } from './SubmissionActions.styles';

type Props = {
  deleting?: boolean;
  id: string;
  onClose: () => void;
  onConfirm: () => void;
  open: boolean;
  studentName: string;
};

const DeleteSubmissionModal = ({
  deleting = false,
  id,
  onClose,
  onConfirm,
  open,
  studentName,
}: Props) => {
  const styles = createStyles();
  const titleId = `${id}-title`;
  const descriptionId = `${id}-description`;
  const formattedStudentName = studentName
    ? `${studentName.charAt(0).toUpperCase()}${studentName.slice(1)}`
    : studentName;

  return (
    <Modal
      aria-describedby={descriptionId}
      aria-labelledby={titleId}
      onClose={deleting ? undefined : onClose}
      onClick={(event) => {
        event.stopPropagation();
        if (event.target === event.currentTarget && !deleting) onClose();
      }}
      open={open}
    >
      <Box onClick={(event) => event.stopPropagation()} sx={styles.modal}>
        <Box sx={styles.modalHeader}>
          <Typography component="h2" id={titleId} sx={styles.modalTitle}>
            Delete submission
          </Typography>
          <Tooltip title="Close">
            <span>
              <IconButton
                aria-label="Close delete submission dialog"
                disabled={deleting}
                onClick={onClose}
                size="small"
                sx={styles.closeButton}
                type="button"
              >
                <Icons.Close />
              </IconButton>
            </span>
          </Tooltip>
        </Box>

        <Box id={descriptionId} sx={styles.modalBody}>
          <Typography sx={styles.message}>
            Do you want to delete {formattedStudentName}’s submission?
          </Typography>
        </Box>

        <Box sx={styles.modalFooter}>
          <Button
            disabled={deleting}
            kind="secondary"
            sx={styles.cancelButton}
            onClick={onClose}
            type="button"
          >
            Cancel
          </Button>
          <Button
            disabled={deleting}
            kind="primary"
            loading={deleting}
            onClick={onConfirm}
            type="button"
          >
            Delete submission
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteSubmissionModal;
